import React from "react";

const RealEstateDisclosure = () => {
  return (
    <section className="oshar-re-disclosure" aria-labelledby="oshar-re-disclosure-title">
      <div className="oshar-inner">
        <h2 id="oshar-re-disclosure-title" className="oshar-re-disclosure__title">
          Legal disclosure
        </h2>
        <div className="oshar-re-disclosure__box">
          <p>
            Oshar virtual property represents digital access and utility within Oshar VR City. It does
            not represent physical real estate, equity ownership, profit-sharing rights, dividend
            rights, or guaranteed income. Game-linked benefits are subject to development, balance,
            legal review, and platform rules.
          </p>
        </div>
      </div>
    </section>
  );
};

export default RealEstateDisclosure;
